export const anchorize = anchor => anchor.replace(/ /g,"").toLowerCase();